<template>
  <div class="header">
    <div class="header-left">
      <img class="logo" :src="data.icon" alt="logo" />
      <div class="title-box">
        <div class="text">{{ data.title }}</div>
        <div class="text">{{ data.desc }}</div>
      </div>
    </div>
    <div class="header-right">
      <a-menu :selectedKeys="current" mode="horizontal" class="headerMenu">
        <div v-for="item in menu" :key="item.key" class="headerMenuItem">
          <a-menu-item :key="item.key">
            <a
              v-if="!item.children"
              @click="toJumpMenu(item)"
              class="headerMenuItemRouter"
              :style="current[0] === item.key ? selectMenu : ''"
            >
              {{ item.title }}
            </a>
            <a-dropdown v-else placement="bottom">
              <a
                class="headerMenuItemRouter"
                :class="item.key === 'active' ? 'tr' : ''"
                :style="current[0] === item.key ? selectMenu : ''"
                >{{ item.title }}</a
              >
              <template #overlay>
                <a-menu class="headerMenuItemDrop">
                  <a-menu-item v-for="i in item.children" :key="i.key">
                    <a>{{ i.title }}</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </a-menu-item>
        </div>
      </a-menu>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const current = ref([''])

const menu = ref([
  {
    key: 'home',
    title: '首页',
    label: '首页',
    router: 'https://isc.360.com/new/'
  },
  // {
  //   key: 'core',
  //   title: '核心业务',
  //   label: '核心业务',
  //   children: [
  //     {
  //       id: 1,
  //       key: 'marketing',
  //       title: '会展营销',
  //       label: '会展营销'
  //     },
  //     {
  //       id: 2,
  //       key: 'consult',
  //       title: '战略咨询',
  //       label: '战略咨询'
  //     },
  //     {
  //       id: 3,
  //       key: 'safe',
  //       title: '安全课',
  //       label: '安全课'
  //     },
  //     {
  //       id: 4,
  //       key: 'media',
  //       title: '媒体公关',
  //       label: '媒体公关'
  //     },
  //     {
  //       id: 5,
  //       key: 'create',
  //       title: '创新孵化',
  //       label: '创新孵化'
  //     },
  //     {
  //       id: 6,
  //       key: 'ecology',
  //       title: '生态联盟',
  //       label: '生态联盟'
  //     }
  //   ]
  // },
  // {
  //   key: 'ISCInternet',
  //   title: 'ISC互联网安全大会',
  //   router: 'https://isc.360.com/2021/events/history.html'
  // },
  {
    key: 'ISC.AI',
    title: 'ISC.AI 2024',
    router: 'https://isc.360.com/new/2024.html'
  },
  {
    key: 'safe',
    title: 'ISC.AI学苑',
    router: 'https://study.360.net/homepage/home'
  },
  {
    key: 'community',
    title: '安全KER',
    router: 'https://shequ.anquanke.com/welcome'
  }
  // {
  //   key: 'about',
  //   title: '关于我们'
  // }
  // {
  //   key:'buyTicket',
  //   title:'购票链接',
  //   router:'https://isc.360.com/2024/ticket'
  // }
])

const selectMenu = {
  color: '#00ab7a'
}

function toJumpMenu(item) {
  const { key, router } = item
  if (router) {
    // current.value[0] = 'home'
    window.open(router)
  }
}
</script>

<style lang="scss" scoped>
.header {
  // padding-top: 22px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 32px 10% 0 12%;
  .header-left{
    display: flex;
    align-items: center;
    .logo {
      // margin-left: 20%;
      height: 48px;
      height: 48px;
    }
    .title-box{
      display: flex;
      flex-direction: column;
      margin-left: 8px;
      .text{
        color: rgb(255, 255, 255);
        font-family: 360shouhu Type;
        font-size: 14px;
        font-weight: 400;
        line-height: -1px;
        letter-spacing: 0px;
      }
    }
  }
  .header-right{
    width: 450px;
  }
  &Menu {
    background: none;
    border-bottom: none;
    // margin-left: 510px;
    &Item {
      &Drop {
        a:hover {
          color: #00ab7a;
        }
        
      }
    }
    &ItemRouter {
      color: rgb(255, 255, 255);
      font-size: 18px;
      font-weight: 350;
    }
    &ItemRouter:hover {
      color: #00ab7a;
    }
  }
}
</style>
